import React from "react"
import PropTypes from "prop-types"
import cn from "classnames"
import { resolveCodeSizeProp } from "./props.js"
import styles from "./code.module.css"

export const Code = ({ children, size = "m", ...props }) => {
  /* eslint-disable-next-line react/prop-types */
  const { style, className, ...rest } = props

  const classes = cn(styles.Code, styles[resolveCodeSizeProp(size)])

  return (
    <code {...rest} className={classes}>
      {children}
    </code>
  )
}

Code.displayName = "Code"

Code.propTypes = {
  /**
   * React node for code content.
   */
  children: PropTypes.node.isRequired,
  /**
   * Controls the size of code content.
   */
  size: PropTypes.oneOf(["s", "m", "l"]),
}

Code.defaultProps = {
  size: "m",
}
